import { NotificationCardType } from 'now-mobile/constants';
import { ModelBase } from 'store/model-base';

export class NowNotificationBanner extends ModelBase {
    public static storeName: string = 'nowNotificationBanner';

    public cardType: string;
    public productName?: string;
    public priority: string;
    public header: string;
    public bodyText: string;
    public ctaText: string;
    public ctaDestination: string;

    public isSuccess: boolean;
    public isWarning: boolean;
    public isWarningReversal: boolean;
    public isPaymentFailure: boolean;
    public isInfo: boolean;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.cardType = data.cardType || '';
        data.header = data.header || '';
        data.productName = data.productName || '';
        data.priority = data.priority || '';
        data.bodyText = data.bodyText || '';
        data.ctaText = data.ctaText || '';
        data.ctaDestination = data.ctaDestination || '';

        data.isSuccess = data.cardType === NotificationCardType.SUCCESS;
        data.isWarning = data.cardType === NotificationCardType.WARNING;
        data.isWarningReversal = data.cardType === NotificationCardType.WARNING_REVERSAL;
        data.isPaymentFailure = data.cardType === NotificationCardType.PAYMENT_FAILURE;
        data.isInfo = data.cardType === NotificationCardType.INFO;

        const notificationBanner: NowNotificationBanner = super.create<NowNotificationBanner>(data);

        return super.create<T>(notificationBanner);
    }
}
